export function offsetToZone(offset) {
  if (offset < 0) {
    return `UTC-${Math.abs(offset)}`; // I want to control the minus char
  }
  if (offset === 0) {
    return 'UTC';
  }
  return `UTC+${Math.abs(offset)}`;
}

export function defaultZone() {
  return (
    $.cookie('search-timezone') ||
    offsetToZone(0 - new Date().getTimezoneOffset() / 60)
  );
}

export function zoneToOffset(zone) {
  if (zone === 'UTC') {
    return 0;
  }
  const offset = parseInt(zone.split('+')[1] || zone.split('-')[1], 10);
  return zone.includes('-') ? -offset : offset;
}
